import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-800">漫画分类</h2>
          <p className="text-sm text-foreground-500 mt-2">多种类型任你选择，发现属于你的韩漫世界</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-3 md:mt-4 font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 text-center">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}